<template>
  <b-overlay :show="load" rounded="sm">
    <div class="media-list media-bordered mycomments" ref="comments">
      <b-media v-for="comment in comments" :key="comment.id">
        <template #aside>
          <b-avatar rounded size="42" :src="comment.user.profile_image_path" />
        </template>

        <h5 class="mt-0">{{ comment.user.full_name }}</h5>
        <b-card-text>{{ comment.created_at }}</b-card-text>
        <b-card-text>
          <b-row>
            <b-col lg="11">
              <span v-if="comment.type == 'text'">
                {{ comment.text }}
              </span>
              <span v-if="comment.type == 'audio'">
                <audio controls :src="comment.meida_data"></audio>
              </span>
              <span v-if="comment.type == 'video'">
                <video
                  width="400"
                  height="250"
                  controls
                  :src="comment.meida_data"
                ></video
              ></span>
            </b-col>
            <b-col lg="1" v-if="user.account_type != 'student'">
              <b-button
                variant="gradient-danger"
                class="btn-icon"
                @click="Delete(comment.id)"
              >
                <feather-icon icon="TrashIcon" /> </b-button
            ></b-col>
          </b-row>
        </b-card-text>

        <b-media
          class="mt-3"
          v-for="children in comment.children"
          :key="children.id"
        >
          <template #aside>
            <b-avatar
              rounded
              size="42"
              :src="children.user.profile_image_path"
            />
          </template>

          <h5 class="mt-0">{{ children.user.full_name }}</h5>
          <b-card-text>{{ children.created_at }}</b-card-text>
          <b-card-text class="mb-0">
            <b-row>
              <b-col lg="11">
                <div v-if="children.type == 'text'">
                  {{ children.text }}
                </div>
              </b-col>
              <b-col lg="1" v-if="user.account_type != 'student'">
                <b-button
                  variant="gradient-danger"
                  class="btn-icon"
                  @click="Delete(children.id)"
                >
                  <feather-icon icon="TrashIcon" /> </b-button
              ></b-col>
            </b-row>
          </b-card-text>
        </b-media>
        <b-media class="mt-3">
          <b-card>
            <b-form>
              <b-row>
                <b-col cols="9">
                  <b-form-group class="mb-2">
                    <b-form-input
                      id="basicInput"
                      :placeholder="$t('comment.comment')"
                      v-model="textCh[comment.id]"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-button
                    variant="primary"
                    @click="add(comment.id, textCh[comment.id])"
                  >
                    {{ $t("comment.add_comment") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-media>
      </b-media>
    </div>
    <!-- Leave a Blog Comment -->
    <hr />
    <b-col cols="12" class="mt-2">
      <h6 class="section-label">{{ $t("comment.leave_comment") }}</h6>
      <b-card>
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-tabs content-class="pt-1" fill v-model="commentTab">
                <b-tab :title="$t('comment.text')">
                  <b-form-group class="mb-2">
                    <b-form-textarea
                      name="textarea"
                      v-model="text"
                      rows="4"
                      :placeholder="$t('comment.comment')"
                    />
                  </b-form-group>
                </b-tab>
                <b-tab :title="$t('comment.audio')">
                  <b-row>
                    <b-col lg="6">
                      <vue-record-audio @result="onResult" />
                    </b-col>
                    <b-col lg="6">
                      <div ref="soundClips"></div>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab :title="$t('comment.video')">
                  <b-row>
                    <b-col lg="6">
                      <vue-record-video
                        thumbnail
                        fluid
                        mode="press"
                        @stream="onVideoStream"
                        @result="onVideoResult"
                        style="
                          z-index: 1000;
                          position: absolute;
                          padding-top: 89px;
                          padding-right: 163px;
                        "
                      />
                      <video
                        ref="SVideo"
                        width="400"
                        height="250"
                        playsinline
                        autoplay
                        muted
                      ></video>
                    </b-col>

                    <b-col lg="6">
                      <video
                        ref="Video"
                        width="400"
                        height="250"
                        controls
                      ></video>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="9">
              <b-button variant="primary" @click="add(0)">
                {{ $t("comment.add_comment") }}
              </b-button>
            </b-col>

            <b-col cols="3" class="float-right">
              <b-button variant="info" @click="exportToPDF">
                {{ $t("comment.export_to_PDF") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-col>
    <!--/ Leave a Blog Comment -->
  </b-overlay>
</template>

<script>
import Comment from "@/Apis/Comment";
import Auth from "@/Apis/Auth";
// import html2pdf from "html2pdf.js";

let comment = new Comment();
export default {
  props: {
    contentId: 0,
    programId: 0,
  },
  data() {
    return {
      comments: [],
      text: "",
      textCh: [],
      load: false,
      audio: "",
      commentTab: 0,

      meidaData: null,
      stream: false,
      user: Auth.USER,
    };
  },
  async created() {
    this.get();
  },
  methods: {
    async add(parent, text) {
      let type = "text";
      let data = {
        contentId: this.contentId,
        programId: this.programId,
        text: this.text,

        type: type,
      };
      if (this.commentTab == 1) {
        data.meidaData = this.meidaData;
        type = "audio";
      }
      if (this.commentTab == 2) {
        data.meidaData = this.meidaData;
        type = "video";
      }
      if (parent == 0) {
        const [ret, show] = await Promise.all([
          comment.storeContentComments(data),
          this.get(),
        ]);

        this.text = "";
      } else {
        const [ret, show] = await Promise.all([
          comment.storeContentComments({
            contentId: this.contentId,
            programId: this.programId,
            text: text,
            parent_id: parent,
            type: "text",
          }),
          this.get(),
        ]);
        this.textCh = [];
      }
    },
    async get() {
      this.load = true;
      let res = await comment.getContentComments(
        this.programId,
        this.contentId
      );
      this.comments = res;
      this.load = false;
      this.meidaData = null;
    },
    exportToPDF() {
      // html2pdf(this.$refs.comments, {
      //   margin: 1,
      //   filename: "comments.pdf",
      //   image: { type: "jpeg", quality: 0.98 },
      //   html2canvas: { dpi: 192, letterRendering: false },
      //   jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
      // });
      const collection = document.getElementsByClassName("mycomments");

      var opt = {
        margin: 1,
        filename: "myfile.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      // New Promise-based usage:
      html2pdf().set(opt).from(collection[1]).save();
    },
    onResult(data) {
      var audio = document.createElement("audio");
      audio.setAttribute("controls", "");
      if (this.$refs.soundClips.lastChild)
        this.$refs.soundClips.removeChild(this.$refs.soundClips.lastChild);
      this.$refs.soundClips.appendChild(audio);
      audio.controls = true;
      audio.src = URL.createObjectURL(data);
      this.meidaData = data;
    },
    onVideoStream(stream) {
      this.stream = true;
      this.$refs.SVideo.srcObject = stream;
    },
    onVideoResult(data) {
      this.stream = false;
      this.$refs.Video.srcObject = null;
      this.$refs.Video.src = window.URL.createObjectURL(data);
      this.meidaData = data;
    },
    async Delete(id) {
      const [ret, show] = await Promise.all([comment.Delete(id), this.get()]);
    },
  },
};
</script>

<style>
</style>
